var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"setting-drawer-index-item"},[_c('h3',{staticClass:"setting-drawer-index-title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default"),(_vm.divider)?_c('a-divider'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }